/** @format */

import React, { useState } from "react";
import { Alert, Button, Form, Modal, Select } from "antd";
import { formatRupiah } from "../../../../utils/helper";
import { getRealizationAll } from "../../../../services/v2/realizationservice";
import { getReportAll } from "../../../../services/v2/reportservice";
import { useDispatch, useSelector } from "react-redux";
import { setStore } from "../../../../redux/actions";
import notifAlert from "../../../../components/NotifAlert";
import { deleteRealisasiPengeluaranKegiatan } from "../../../../services/v2/realizationservice/pengeluarankegiatanservices";

type FormActionType = {
  openModal: boolean;
  handleClose: () => void;
};

const ModalCheckSelisih = ({ openModal, handleClose }: FormActionType) => {
  const store = useSelector((state: any) => state.store);
  const auths = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();
  const tmpSumberDana = store.rencanaPendapatanDefinitif || [];
  let tmpRealisasiBiaya = store.realisasiBiaya || [];

  //

  const tmpRencanaRincianKegiatanDefinitif =
    (store.rencanaRincianKegiatanDefinitif?.length &&
      store.rencanaRincianKegiatanDefinitif
        .filter(
          (item: any) => item.kepalaMadrasahApproved === "1",
          // && item?.status === "DISETUJUI",
        )
        .map((item) => {
          const matchingItems = tmpRealisasiBiaya.filter(
            (item2) => item.id === item2.rencanaRincianKegiatanId,
          );

          if (matchingItems) {
            return {
              ...item,
              noNota: matchingItems.map((data) => ({
                no: data.noNotaFormat,
                status: data.status,
              })),
              numbNota: matchingItems.map((data) => data.noNotaFormat),
            };
          }
          return item;
        })) ||
    [];
  const [form] = Form.useForm();
  const [nilaiSelisih, setNilaiSelisih] = useState<any>(0);
  const [deleteId, setDeleteID] = useState<any>([]);
  const [loading, setLoading] = useState<any>(false);

  const handleChange = (values: any) => {
    if (values.sumberDana) {
      checkSelisih(values.sumberDana);
    }
  };

  const handleAfterClose = () => {
    form.resetFields();
    setNilaiSelisih(0);
    setDeleteID([]);
    handleClose();
  };

  const checkSelisih = (kode: any) => {
    setLoading(true);
    let listID: any = [];
    let totalJumlahTotal: any = 0;
    let rincianRencanaDef = tmpRencanaRincianKegiatanDefinitif.filter((item) =>
      item.alokasiPendapatan.some(
        (items) => items.rencana_pendapatan.kode_sumber_dana === kode,
      ),
    );
    const listRincianRencanaId = rincianRencanaDef.map((item) => item.id);
    tmpRealisasiBiaya
      .filter(
        (item) => !listRincianRencanaId.includes(item.rencanaRincianKegiatanId),
      )
      .filter(
        (item) =>
          item.biayaSumberDanas.some(
            (iitem) => iitem.kodeSumberDana === kode,
          ) && item.status === "SELESAI",
      )
      // eslint-disable-next-line array-callback-return
      .map((item: any) => {
        listID.push(item.id);
        totalJumlahTotal += item.grandTotal;
      });
    setNilaiSelisih(totalJumlahTotal);
    setDeleteID(listID);
    setLoading(false);
  };

  const reloadData = async () => {
    try {
      const realisasiBiaya = await getRealizationAll("biaya", {
        tahun: auths.isTahun,
      });
      const realisasiPendapatanHeader =
        (await getReportAll("pendapatan/header", {
          tahun: auths.isTahun,
        })) || null;
      setTimeout(() => {
        dispatch(setStore({ realisasiBiaya, realisasiPendapatanHeader }));
      }, 100);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async (values: any) => {
    setLoading(true);
    try {
      await Promise.all(
        values.map((id: any) => deleteRealisasiPengeluaranKegiatan(id)),
      );
    } catch (error) {
      console.log(error);
    } finally {
      notifAlert({
        type: "success",
        description: "Data Berhasil di hapus",
      });

      reloadData();
      handleAfterClose();
      setLoading(false);
    }
  };
  return (
    <Modal
      open={openModal}
      title={`Bersihkan Selisih`}
      width={1000}
      onCancel={handleAfterClose}
      confirmLoading={loading}
      footer={<Button onClick={handleAfterClose}>Kembali</Button>}>
      <Alert
        type="warning"
        showIcon
        style={{ marginBottom: 20 }}
        message={<span className="font-bold">Perhatian</span>}
        description={
          <>
            Menu ini akan membantu data transaksi madrasah mengalami selisih di
            dashboard dan nilai sumber dana tidak bisa digunakan untuk realisasi
            pengeluaran kegiatan. Pilih terlebih dahulu sumber dana yang
            mengalami selisih, pastikan nilai selisih sesuai dengan nilai yang
            ada di dashboard lalu tekan tombol Hapus Transaksi.
          </>
        }
      />
      <Form
        form={form}
        key="modalformSelisih"
        name="modalformSelisih"
        layout="vertical"
        onValuesChange={handleChange}>
        <Form.Item
          label="Sumber Dana"
          name="sumberDana"
          rules={[
            {
              required: true,
              message: "Sumber Dana tidak boleh kosong!",
            },
          ]}>
          <Select
            showSearch
            optionFilterProp="children"
            placeholder="Pilih Sumber Dana">
            {tmpSumberDana.length &&
              tmpSumberDana.map((item: any, i: any) => {
                return (
                  <Select.Option key={`snp${i}`} value={item.kode_sumber_dana}>
                    {item.nama_sumber_dana}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <div className="text-2xl">Nilai Selisih</div>
        <div className="text-xl mb-4">{formatRupiah(nilaiSelisih)}</div>
        {nilaiSelisih > 0 && (
          <Button
            onClick={() => {
              Modal.confirm({
                title: "Perhatian",
                content: "Yakin Hapus Data?",
                onOk() {
                  return handleDelete(deleteId);
                },
                onCancel() {},
                okText: "Hapus",
                cancelText: "Batal",
                okType: "danger",
              });
            }}
            danger>
            Hapus Transaksi
          </Button>
        )}
      </Form>
    </Modal>
  );
};
export default ModalCheckSelisih;
